import { Component, Inject, ChangeDetectorRef, Input } from "@angular/core";

import { VisualizationPanel, ConfVisualizationValue } from "../../../shared/models";
import { PanelComponent } from "../../shared/panelComponent";
import { ConfiguratorStore, ConfPageSessionService } from "../../providers";
import { VisualObjectVisibilityService } from "../../shared";
import { GlobalDataStore } from "../../../shared/providers/globalData";
import { VisualObjectHelper } from "../../parameters/shared";

@Component({
  selector: 'visualization-panel',
  templateUrl: './visualizationPanelComponent.html'
})
export class VisualizationPanelComponent extends PanelComponent<VisualizationPanel> {

  public confVisualizationValue: ConfVisualizationValue;
  public hasTitle: boolean = false;

  visualizationHeight: string;

  visualizationMaxHeight: string;

  styles: string = "visualization-body";

  @Input()
  public isEditor: boolean = true;

  constructor(
    @Inject(ConfiguratorStore) public confStore: ConfiguratorStore,
    @Inject(ConfPageSessionService) public confPageSessionService: ConfPageSessionService,
    public visualObjectVisibilityService: VisualObjectVisibilityService,
    @Inject(VisualObjectHelper) public visualObjectHelper: VisualObjectHelper,
    public globalDataStore: GlobalDataStore,
    public cdr: ChangeDetectorRef
  ) {
    super(confStore, confPageSessionService, visualObjectHelper);
  }

  ngOnInit() {

    if (this.visualObjectHelper.isVisualObjectInAccordion(this.panel)) {

      this.visualizationHeight = this.panel.height ? this.panel.height + 'px' : this.uiSettings.configurator.panel.minHeight;
      this.visualizationMaxHeight = '100%';
    }
    else
    {
      if (this.panel.responsiveSize) {
        this.visualizationMaxHeight = '100%';
      }
      else this.visualizationMaxHeight = this.panel.height ? this.panel.height + 'px' : this.uiSettings.configurator.panel.minHeight;

      this.visualizationHeight = '100%';
    }
    
    this.styles += this.hasTitle ? " py-2" : " no-gutters";
    super.ngOnInit();
  }

  public listenChanges(): void {

    this.hasTitle = this.showTitle && this.panel.title && this.panel.title.trim().length > 0;
    this.confVisualizationValue = this.getConfVisualizationValue();

    this.confStore.onConfigurationValueChange<ConfVisualizationValue>(this.configurationId, this.confSessionId, this.panel.visualObjectId,
        (confVisualizationValue): void => {

          this.confVisualizationValue = confVisualizationValue;

        }).unsubscribeOn(this.unsubscribeSubject);
  }

  getConfVisualizationValue() {
    return this.confStore.getConfDataEntity<ConfVisualizationValue>(this.configurationId, this.confSessionId, this.panel.visualObjectId);
  }

  public cancelScrollEvent() {
    return false;
  }
}